/*
 * Copyright (c) 2019. AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { sanitize } from "dompurify";

export const makeSafeReactInnerHTML = (htmlString: string): { __html: string } => {
  return { __html: sanitize(htmlString) };
};

export const makeSafeHtmlAsText = (htmlString: string): string => {
  const intermediateElement = document.createElement("a");
  intermediateElement.innerHTML = sanitize(htmlString);
  return intermediateElement.innerText;
};
